// extracted by mini-css-extract-plugin
module.exports = {"main-component":"newTag_main-component__xW5x9"};